import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SafePipe} from "./pipes/safe.pipe";
import {IndianNumberPipe} from "./pipes/indian-number.pipe";
import {NumberOnlyDirective} from "./directives/number-only.directive";
import {TruncatePipe} from "./pipes/truncate.pipe";

@NgModule({
  declarations: [
    SafePipe,
    IndianNumberPipe,
    NumberOnlyDirective,
    TruncatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafePipe,
    IndianNumberPipe,
    NumberOnlyDirective,
    TruncatePipe
  ]
})
export class SharedModule {
}
